import { render } from "./PayProviders.vue?vue&type=template&id=41ae60db&scoped=true"
import script from "./PayProviders.vue?vue&type=script&lang=js"
export * from "./PayProviders.vue?vue&type=script&lang=js"

import "./PayProviders.vue?vue&type=style&index=0&id=41ae60db&scoped=true&lang=css"

import exportComponent from "/opt/apps/golden_telecom/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-41ae60db"]])

export default __exports__